<script lang="ts" context="module">
  export interface IContact {
    firstName: string;
    lastName: string;
    phone: string;
    photo: IUPicture | null;
    position: string;
    email: string;
  }
</script>

<script lang="ts">
  import type { IUPicture } from "../../core/types";
  import UPicture from "../../core/u-elements/UPicture.svelte";

  export let isLightMode: boolean = false;
  export let isLarge: boolean = false;
  export let data: IContact;
</script>

<div class="user-info" class:isLightMode class:isLarge>
  {#if data?.photo}
    <UPicture class="user-info-avatar" data={data.photo} width={100} />
  {:else}
    <span class="user-info-avatar" />
  {/if}
  <div class="user-info-column">
    {#if data?.firstName || data?.lastName}
      <p class="user-info-title">{data?.firstName} {data?.lastName}</p>
    {/if}

    {#if data?.position}
      <p>{data?.position}</p>
    {/if}

    {#if data?.email}
      <p>
        <svg
          class="icon"
          width="16"
          height="11"
          class:white-color={isLightMode}
          aria-label="email"
        >
          <use xlink:href="#email" />
        </svg>

        <a class="link" href="mailto:{data?.email}">
          {data?.email}
        </a>
      </p>
    {/if}

    {#if data?.phone}
      <p>
        <svg
          class="icon"
          width="16"
          height="12"
          class:white-color={isLightMode}
          aria-label="phone"
        >
          <use xlink:href="#phone" />
        </svg>
        <a class="link" href="tel:{data?.phone}">{data?.phone}</a>
      </p>
    {/if}
  </div>
</div>

<style lang="scss">
  .user-info {
    display: flex;
    @include small;

    &.isLightMode {
      color: $text-reverse-color;

      .icon {
        fill: $text-reverse-color;
      }

      .link {
        color: inherit;
      }
    }

    &:not(.isLightMode) {
      .icon {
        fill: $key-color;
      }
    }

    &.isLarge {
      @include normal;

      :global(.user-info-avatar) {
        margin-right: 24px;
      }
    }
  }

  :global(.user-info-avatar) {
    width: 100px;
    min-width: 100px;
    height: 100px;
    border-radius: 50%;
    margin-right: 15px;
    background-color: $text-reverse-color;
    object-fit: cover;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  }

  .user-info-column {
    word-break: break-all;

    p {
      margin-bottom: 4px;
    }

    .icon {
      vertical-align: middle;
      margin-right: 4px;
    }
  }

  .user-info-title {
    font-weight: 700;
  }
</style>
